import { FC, useState } from 'react'
import { RedRed60, SequenceMenu } from '@sequencehq/core-components'
import { VoidCreditNoteDialog } from 'CreditNotes/components/dialog/VoidCreditNoteDialog'

type Props = {
  creditNoteId: string
  onClose: () => void
}

export const VoidCreditNoteMenuItem: FC<Props> = ({
  creditNoteId,
  onClose
}) => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <SequenceMenu.Item
        uuid="void-credit-note"
        data-testid={`creditNotes.${creditNoteId}.menuItem.void`}
        label="Void credit note"
        style={{ color: RedRed60 }}
        onClick={e => {
          e.stopPropagation()
          setShowModal(true)
        }}
      />
      {showModal && (
        <VoidCreditNoteDialog
          creditNoteId={creditNoteId}
          isOpen
          onClose={() => {
            setShowModal(false)
            onClose()
          }}
        />
      )}
    </>
  )
}
